import React, { useState, useEffect } from 'react';
// 1. Import components from react-router-dom
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';

// Layout Components
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Modal from './components/common/Modal';
import ScrollToTop from './components/common/ScrollToTop';

// Page Components
import HomePage from './pages/HomePage';
import DashboardPage from './pages/DashboardPage';
import PricingPage from './pages/PricingPage';
import DocumentationPage from './pages/DocumentationPage';
import ContactPage from './pages/ContactPage';
import AboutUsPage from './pages/AboutUsPage';
import LegalPage from './pages/LegalPage';
import NewsPage from './pages/NewsPage';
import ArticleDetailPage from './pages/ArticleDetailPage';

// Auth Components
import LoginPage from './auth/LoginPage';
import SignupPage from './auth/SignupPage';

import TermsPage from './pages/TermsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';

import './App.css';
import './index.css';

function App() {
    const [modalType, setModalType] = useState(null);
    const { user, loading } = useAuth();

    // The 'page' state and 'navigate' function are no longer needed for routing.
    
    // The useEffect can be simplified or removed depending on desired redirect behavior
    useEffect(() => {
        if (!loading && user) {
            if (modalType === 'login' || modalType === 'signup') {
                setModalType(null);
            }
        }
    }, [user, loading, modalType]);

    if (loading && !user) {
        return <div className="flex justify-center items-center min-h-screen font-montserrat"><div>Loading Application...</div></div>;
    }

    // You will need to check for the dashboard route differently.
    // This can be done with the `useLocation` hook in the Navbar if needed.

    return (
        // 2. Wrap the entire application in <Router>
        <Router>
            <ScrollToTop />
            <div className="font-montserrat bg-gradient-to-br from-black via-black to-[#7B34BB] min-h-screen flex flex-col">
                {modalType && (
                    <Modal onClose={() => setModalType(null)}>
                        {modalType === 'login' && <LoginPage setModalType={setModalType} closeModal={() => setModalType(null)} />}
                        {modalType === 'signup' && <SignupPage setModalType={setModalType} closeModal={() => setModalType(null)} />}
                    </Modal>
                )}

                {/* You can add logic here or in the Navbar to hide it on the dashboard route */}
                <Navbar openModal={setModalType} />
                
                <main className="flex-1">
                    {/* 3. Replace the renderPage() call with the <Routes> component */}
                    <Routes>
                        {/* Public Routes */}
                        <Route path="/" element={<HomePage openModal={setModalType} />} />
                        <Route path="/pricing" element={<PricingPage openModal={setModalType} />} />
                        <Route path="/about" element={<AboutUsPage />} />
                        <Route path="/documentation" element={<DocumentationPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/terms" element={<TermsPage/>} />
                        <Route path="/privacy" element={<PrivacyPolicyPage />} />
                        <Route path="/news" element={<NewsPage />} />
                        <Route path="/news/:slug" element={<ArticleDetailPage />} />

                        {/* Protected Route */}
                        <Route 
                            path="/dashboard" 
                            element={user ? <DashboardPage /> : <Navigate to="/" replace />}
                        />
                        
                        {/* Legal redirect route */}
                        <Route path="/legal" element={<Navigate to="/terms" replace />} />
                        
                        {/* Fallback Route */}
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </main>
                
                {/* You can add logic here or in the Footer to hide it on the dashboard route */}
                <Footer />
            </div>
        </Router>
    );
}

export default App;